var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFigma = function SvgFigma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.5 2.5a2.5 2.5 0 1 0 0 5H11v-5zm4.5 0v5h2.5a2.5 2.5 0 1 0 0-5zm5.328 6A4.5 4.5 0 0 0 20 5 4.5 4.5 0 0 0 15.5.5h-7a4.5 4.5 0 0 0-2.828 8 4.502 4.502 0 0 0 0 7q-.184.15-.354.318A4.5 4.5 0 1 0 13 19v-3.258a4.5 4.5 0 0 0 2.5.758 4.501 4.501 0 0 0 2.828-8M11 14.5v-5H8.5a2.5 2.5 0 0 0 0 5zm0 2H8.5A2.5 2.5 0 1 0 11 19zm4.5-7a2.5 2.5 0 1 0 0 5.001 2.5 2.5 0 0 0 0-5.001",
    clipRule: "evenodd"
  })));
};
export default SvgFigma;